import { ca } from '@cian/analytics';

export function trackChangeFiltersClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Map',
    action: 'click_empty_area',
    label: 'change',
  });
}
